import { LoadingIndicator } from "@/Icons/loadingIndicator";
import { useTerminalsState } from "@/States/Terminals";
import { PieWasteContribution } from "@/components/Graphs/PieWasteContribution";
import { Page } from "@/components/Page";

import { InactiveTenantsCard } from "./components/inactiveTenantsCard";
import { MixedWastePerformance } from "./components/mixedWastePerformance";
import { PercentagePerformance } from "./components/percentagePerformance";

export const TenantDashboard = () => {
  const { currentTerminal } = useTerminalsState();

  return (
    <Page title="sidebarLabels:tenantFollowUp">
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
        {!currentTerminal?.id ? (
          <div className="flex justify-center">
            <LoadingIndicator />
          </div>
        ) : (
          <>
            <PercentagePerformance />
            <MixedWastePerformance />
            <PieWasteContribution />
            <InactiveTenantsCard />
          </>
        )}
      </div>
    </Page>
  );
};

export default TenantDashboard;
